import React, { useEffect, useState } from "react";
import "../CSS/Blogs.css";


const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await fetch("https://api.aikanksha.com/api/posts?limit=6");

        if (!res.ok) throw new Error("Failed to fetch blogs");

        const data = await res.json();
        console.log("Beehiiv API Response:", data); // Debug log
        setBlogs(data.data || []);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  if (loading) {
    return (
      <section className="blogs">
        <p className="loading">Loading blogs...</p>
      </section>
    );
  }

  return (
    <section className="blogs">
<div className="blogs-header">
  <h2>
    Latest from <span>FastFeedAI</span>
  </h2>
  <p>Your weekly AI insights, tips, and news — straight from our Beehiiv blog.</p>
</div>


      <div className="blogs-grid">
{blogs
  .filter((blog) => 
    (blog.meta_default_description && blog.meta_default_description.trim() !== '') ||
    (blog.content && blog.content.trim() !== '')
  )
  .slice(0, 6) // limit max 6 here for safety on frontend also
  .map((blog) => {
    const imageUrl = blog.thumbnail_url || "";
    const summary = blog.meta_default_description?.trim() || blog.content?.trim() || "";

    return (
      <div key={blog.id} className="blog-card small-card">
        <a href={blog.web_url} target="_blank" rel="noopener noreferrer" className="blog-link">
          {imageUrl && (
            <div className="blog-image small-image">
              <img src={imageUrl} alt={blog.title} loading="lazy" />
            </div>
          )}
          <div className="blog-content">
            <h3 className="title">{blog.title}</h3>
            <p className="summary">{summary}</p>
          </div>
        </a>
<div className="notify-btn-container">
  <a href="#newsletter" className="notify-btn">
    Get Notified →
  </a>
</div>


      </div>
    );
  })}



      </div>
    </section>
  );
};

export default Blogs;
